import React, { useState } from "react";
import axios from "axios";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table, Modal } from "react-bootstrap";
import {
  WithdrawalRequestActions,
  updateTokenTransactionAsync,
} from "../../redux";
import BasicPagination from "../../../pagination/BasicPagination";
import { CircularProgress } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import moment from "moment";

const WithdrawalRequestTable = () => {
  const { isLoading, transactionList, skip, limit } = useSelector(
    (state) => state.withdrawalRequest,
    shallowEqual
  );

  const [ApproveModal, setApproveModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const deleteClose = () => {
    setApproveModal(false);
    setShowTextBox(false);
  };
  const deleteShow = () => setApproveModal(true);
  const [showTextBox, setShowTextBox] = useState(false);
  const [reasonDecline, setReasonDecline] = useState("");
  const dispatch = useDispatch();
  const [selectedTokenName, setselectedTokenName] = useState({});
  const [historyLoading, setHistoryLoading] = useState(false);
  const [userHistory, setUserHistory] = useState([]);
  const [userHistoryCount, setUserHistoryCount] = useState(0);
  const [userHistoryPage, setUserHistoryPage] = useState(0);
  const userHistoryLimit = 10;
  const [selectedUsername, setSelectedUsername] = useState("");
  const [betHistoryModal, setBetHistoryModal] = useState(false);
  const [betHistoryLoading, setBetHistoryLoading] = useState(false);
  const [betHistory, setBetHistory] = useState([]);
  const [betHistoryCount, setBetHistoryCount] = useState(0);
  const [betHistoryPage, setBetHistoryPage] = useState(0);
  const betHistoryLimit = 10;

  //on page change
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(WithdrawalRequestActions.setVirtualTokenBatchNumber(count));
  };
  //show approv model and change approv status
  const onApprovedClick = (transactionData) => {
    setselectedTokenName(transactionData);
    deleteShow();
  };

  const openHistoryModal = async (username, page = 0) => {
    setHistoryModal(true);
    setHistoryLoading(true);
    setSelectedUsername(username || "");
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/tokentransactions/getAllTokenTransaction`,
        headers: { "Content-Type": "application/json" },
        data: {
          search: username,
          skip: page,
          limit: userHistoryLimit,
        },
      });
      if (data?.statusCode === 200) {
        setUserHistory(data?.data?.transactionList || []);
        setUserHistoryCount(data?.data?.count || 0);
        setUserHistoryPage(page);
      } else {
        setUserHistory([]);
        setUserHistoryCount(0);
      }
    } catch (e) {
      setUserHistory([]);
      setUserHistoryCount(0);
    } finally {
      setHistoryLoading(false);
    }
  };

  const closeHistoryModal = () => {
    setHistoryModal(false);
    setUserHistory([]);
    setUserHistoryCount(0);
    setUserHistoryPage(0);
    setSelectedUsername("");
  };

  const openBetHistoryModal = async (username, page = 0) => {
    setBetHistoryModal(true);
    setBetHistoryLoading(true);
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/bet/getAllBet?skip=${page}&limit=${betHistoryLimit}&search=${encodeURIComponent(
          username || ""
        )}&disputeType=&sortType=&sortBy=`,
        headers: { "Content-Type": "application/json" },
      });
      if (data?.statusCode === 200) {
        setBetHistory(data?.data?.betList || data?.data?.bets || []);
        setBetHistoryCount(data?.data?.count || 0);
        setBetHistoryPage(page);
      } else {
        setBetHistory([]);
        setBetHistoryCount(0);
      }
    } catch (e) {
      setBetHistory([]);
      setBetHistoryCount(0);
    } finally {
      setBetHistoryLoading(false);
    }
  };

  const closeBetHistoryModal = () => {
    setBetHistoryModal(false);
    setBetHistory([]);
    setBetHistoryCount(0);
    setBetHistoryPage(0);
  };

  //change status of debit transaction for user
  const handleToggle = () => {
    const obj = {
      withdrawal_approved: true,
      user_id: selectedTokenName.user_id,
      amount: selectedTokenName.amount,
      transactionId: selectedTokenName.transactionId
        ? selectedTokenName.transactionId
        : "",
    };
    dispatch(updateTokenTransactionAsync(obj, selectedTokenName._id));
    setselectedTokenName({});
    deleteClose();
  };

  const handleDiclineToggle = () => {
    setShowTextBox(true);
  };

  const handleDiclineSubmit = () => {
    const obj = {
      is_decline: true,
      decline_reason: reasonDecline,
      user_id: selectedTokenName.user_id,
      amount: selectedTokenName.amount,
      transactionId: selectedTokenName.transactionId
        ? selectedTokenName.transactionId
        : "",
    };
    dispatch(updateTokenTransactionAsync(obj, selectedTokenName._id));
    setselectedTokenName({});
    deleteClose();
  };

  return (
    <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
      <div className="tblmrgn mt-0">
        <div className="mt-5">
          <div>
            <Table
              hover
              responsive
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>User Name</th>
                  <th>Requested Token to Withdraw</th>
                  <th>Total Tokens</th>
                  <th>Created At</th>
                  <th>Action By Admin</th>
                  <th>Decline Reason</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {transactionList.data &&
                transactionList.data.transactionList.length ? (
                  transactionList.data.transactionList.map(
                    (transactionLists, index) => (
                      <tr key={index}>
                        <td>
                          <span className="f-w-500">
                            {skip * limit + (index + 1)}
                          </span>
                        </td>
                        <td>
                          <span>{transactionLists.userName}</span>
                        </td>

                        <td>{transactionLists.amount}</td>
                        <td>{transactionLists.total_token}</td>

                        <td>
                          {transactionLists?.createdAt
                            ? moment(transactionLists.createdAt).format(
                                "MMM Do YYYY, h:mm:ss a"
                              )
                            : "-"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            value={
                              transactionLists &&
                              transactionLists.withdrawal_approved
                            }
                            className={`pmnt_btn ${
                              transactionLists
                                ? transactionLists.withdrawal_approved ===
                                    false &&
                                  transactionLists.is_decline === false
                                  ? "label label-lg label-light-warning label-inline"
                                  : transactionLists.withdrawal_approved ===
                                    true
                                  ? "label label-lg label-light-success label-inline"
                                  : transactionLists.is_decline === true
                                  ? "label label-lg label-light-danger label-inline" // Added red color for decline
                                  : ""
                                : ""
                            }`}
                            onClick={() => {
                              if (
                                !transactionLists.withdrawal_approved &&
                                !transactionLists.is_decline
                              ) {
                                onApprovedClick(transactionLists);
                              }
                            }}
                          >
                            {transactionLists &&
                            transactionLists.withdrawal_approved === false &&
                            transactionLists.is_decline === false
                              ? "Pending"
                              : transactionLists.withdrawal_approved === true
                              ? "Approved"
                              : transactionLists.is_decline === true
                              ? "Declined"
                              : "-"}
                          </button>
                        </td>
                        <td>
                          {transactionLists.decline_reason
                            ? transactionLists.decline_reason
                            : "-"}
                        </td>
                        <td>
                           <a
                            title="Transaction History"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            onClick={() => openHistoryModal(transactionLists?.userName || "")}
                            style={{marginTop: "5px"}}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                               <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Clipboard-list.svg"
                                )}
                              />
                            </span>
                          </a>

                              <a
                            title="Bet History"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                           onClick={() => openBetHistoryModal(transactionLists?.userName || "")}
                            target="_blank"
                            style={{marginTop: "5px"}}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Spam.svg"
                                )}
                              />
                            </span>
                          </a>


                        </td>
                        
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
                {isLoading && (
                  <tr>
                    <td colSpan={8} className="text-center">
                      <div className="basic-verification-loader text-center">
                        <CircularProgress />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="row d-flex align-items-center mr-5 ml-5 mt-4 btm-pagination">
            <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-left">
              Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
              {transactionList?.data?.count} Records
            </div>
            <div className="col-md-8 text-left mb-5 aspgntn">
              <BasicPagination
                totalRecords={transactionList?.data?.count}
                limit={limit}
                batch={skip + 1}
                onBatchChange={onPageChange}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={ApproveModal}
        onHide={deleteClose}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form def_form frmwtpddng">
            <p className="fn_s_18 f-w-400 text-center mb-10">
              Are you sure you want to Approve or Decline transaction?
            </p>

            {showTextBox == true ? (
              <input
                placeholder="Add reason for decline"
                type="text"
                className={`form-control full-text-box  pl-3`}
                name="decline_reason"
                onChange={(e) => {
                  setReasonDecline(e.target.value);
                }}
              />
            ) : null}

            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
              <div className="form-group mr-5 mb-1 mt-2">
                <button
                  className="btn_new btn-sm"
                  type="button"
                  onClick={deleteClose}
                >
                  Close
                </button>
              </div>
              {showTextBox == false ? (
                <div className="form-group mr-5 mb-1 mt-2">
                  <button
                    className="btn_new btn-sm"
                    type="button"
                    onClick={handleToggle}
                  >
                    Approve it
                  </button>
                </div>
              ) : null}
              {showTextBox == false ? (
                <div className="form-group mr-5 mb-1 mt-2">
                  <button
                    className="btn_new btn-sm"
                    type="button"
                    onClick={handleDiclineToggle}
                  >
                    Decline it
                  </button>
                </div>
              ) : (
                reasonDecline !== "" && (
                  <div className="form-group mr-5 mb-1 mt-2">
                    <button
                      className="btn_new btn-sm"
                      type="button"
                      onClick={handleDiclineSubmit}
                    >
                      Submit
                    </button>
                  </div>
                )
              )}
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        show={historyModal}
        onHide={closeHistoryModal}
        centered
        className="def_modal delete_modal"
        size="xl"
      >
        <Modal.Header
        closeButton
          style={{
            background:
              "linear-gradient(90deg, rgba(26,26,26,1) 0%, rgba(48,48,48,1) 50%, rgba(26,26,26,1) 100%)",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <Modal.Title className="fn_s_18 color_blk f-w-700" style={{ width: "100%" }}>
            <div className="d-flex align-items-center justify-content-between w-100">
              <span>User Transaction History</span>
             
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {historyLoading ? (
            <div className="text-center"><CircularProgress /></div>
          ) : (
            <div style={{ maxHeight: 520, overflow: "auto", paddingRight: 6, color: "#fff" }}>
              <div className="d-flex justify-content-between align-items-center mb-3 pr-2 pl-1">
                <div className="d-flex align-items-baseline">
                  <div className="fn_s_16 f-w-600 mr-3">{selectedUsername || "-"}</div>
                  <div className="fn_s_12" style={{ opacity: 0.7 }}>Latest {Math.min(userHistoryLimit, userHistoryCount)} of {userHistoryCount}</div>
                </div>
              </div>

              <Table responsive className="mb-0 default_table with_hoverbtn mrpdng_tbl">
                <thead style={{ position: "sticky", top: 0, zIndex: 1, background: "rgba(0,0,0,0.6)", color: "#fff" }}>
                  <tr>
                    <th style={{ borderTop: 0 }}>#</th>
                    <th style={{ borderTop: 0 }}>Date</th>
                    <th style={{ borderTop: 0 }}>Type</th>
                    <th style={{ borderTop: 0 }}>Transaction Type</th>
                    <th className="text-right" style={{ borderTop: 0 }}>Token</th>
                    <th style={{ borderTop: 0 }}>Status</th>
                  </tr>
                </thead>
                <tbody  style={{background: "rgba(0,0,0,0.6)", color: "#FFF",fontSize:"15px" }}>
                  {userHistory && userHistory.length ? (
                    userHistory.map((tx, idx) => (
                      <tr key={tx._id || idx}>
                        <td>{userHistoryPage * userHistoryLimit + (idx + 1)}</td>
                        <td>{tx?.createdAt ? moment(tx.createdAt).format("MMM Do YYYY, h:mm a") : "-"}</td>
                        <td>
                          <span className={`label label-inline ${tx?.transaction_type === "CREDIT" ? "label-light-primary" : "label-light-warning"}`}>
                            {tx?.transaction_type || "-"}
                          </span>
                        </td>
                        <td>
                           {
                        !tx.isCancelMatch && !tx.isVoidMatch
                        ? tx.transaction_type === "CREDIT" &&
                        tx.balance_type === "NON_WITHDRAWABLE" &&
                        tx.description === "DEPOSITED_BY_ADMIN"
                        ? "Deposited By Admin"
                        : tx.transaction_type === "CREDIT" &&
                        tx.description?.startsWith("RESULT_CLAIM")
                        ? "Result Claim"
                        : tx.transaction_type === "CREDIT" &&
                        tx.description?.startsWith("RESULT_BY_ADMIN")
                        ? "Result By Admin"
                        : tx.transaction_type === "CREDIT" &&
                        tx.description?.startsWith("CANCEL_BET")
                        ? "Cancelled Bet Refund"
                        : tx.transaction_type === "CREDIT" &&
                        tx.balance_type === "NON_WITHDRAWABLE" &&
                        tx.description?.startsWith("REFERRAL_BONUS")
                        ? "Referral Bonus"
                        : tx.transaction_type === "CREDIT" &&
                        tx.balance_type === "NON_WITHDRAWABLE" &&
                        tx.description?.startsWith("REFERRAL_SIGNUP_BONUS")
                        ? "Signup Bonus"
                        : tx.transaction_type === "CREDIT" &&
                        tx.balance_type === "NON_WITHDRAWABLE" &&
                        tx.description?.startsWith("PROMO_CODE_APPLIED")
                        ? "Deposit By Promo Code"
                        : tx.transaction_type === "CREDIT" &&
                        tx.balance_type === "NON_WITHDRAWABLE"
                        ? "Deposit"
                        : tx.transaction_type === "DEBIT" &&
                        tx.balance_type === "WITHDRAWABLE" &&
                        tx.withdrawal_approved === false
                        ? "Withdrawal Requested"
                        : tx.transaction_type === "DEBIT" &&
                        tx.balance_type === "WITHDRAWABLE" &&
                        tx.withdrawal_approved === true
                        ? "Withdrawal Success"
                        : tx.transaction_type === "CREDIT" &&
                        tx.balance_type === "WITHDRAWABLE" &&
                        tx.is_decline === true
                        ? "Withdrawal Declined"
                        : tx.transaction_type === "CREDIT" &&
                        tx.balance_type === "WITHDRAWABLE" &&
                        tx.description?.startsWith("RESULT_CLAIM")
                        ? "Result Claim"
                        : tx.transaction_type === "CREDIT" &&
                        tx.balance_type === "WITHDRAWABLE"
                        ? "Won Bet"
                        : tx.transaction_type === "DEBIT" &&
                        tx.balance_type === "NON_WITHDRAWABLE"
                        ? "Created/Joined Bet"
                        : tx.transaction_type === "DEBIT" &&
                        tx.balance_type === "WITHDRAWABLE"
                        ? "Withdrawal"
                        : ""
                        : tx.isCancelMatch
                        ? tx.transaction_type === "DEBIT" &&
                        tx.balance_type === "NON_WITHDRAWABLE"
                        ? "Created/Joined Bet"
                        : "Cancelled Bet"
                        : tx.isVoidMatch
                        ? tx.transaction_type === "DEBIT" &&
                        tx.balance_type === "NON_WITHDRAWABLE"
                        ? "Created/Joined Bet"
                        : "Voided Bet"
                        : ""
                        }
                        </td>
                        <td className="text-right">{tx?.amount ?? "-"}</td>
                        <td>
                          <span className={`label label-inline ${tx?.status === "SUCCESS" ? "label-light-success" : tx?.status === "PENDING" ? "label-light-warning" : "label-light-danger"}`}>
                            {tx?.status || "-"}
                          </span>
                        </td>
                        
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">No Records</td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {userHistoryCount > userHistoryLimit && (
                <div className="d-flex justify-content-end mt-4 pr-2">
                  <BasicPagination
                    totalRecords={userHistoryCount}
                    limit={userHistoryLimit}
                    batch={userHistoryPage + 1}
                    onBatchChange={(batch) => openHistoryModal(selectedUsername || "", (batch ? batch - 1 : 0))}
                  />
                </div>
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* User Bet History Modal */}
      <Modal
        show={betHistoryModal}
        onHide={closeBetHistoryModal}
        centered
        className="def_modal delete_modal"
        size="xl"
      >
        <Modal.Header
        closeButton
          style={{
            background:
              "linear-gradient(90deg, rgba(26,26,26,1) 0%, rgba(48,48,48,1) 50%, rgba(26,26,26,1) 100%)",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <Modal.Title className="fn_s_18 color_blk f-w-700" style={{ width: "100%" }}>
            <div className="d-flex align-items-center justify-content-between w-100">
              <span>User Bet History</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {betHistoryLoading ? (
            <div className="text-center"><CircularProgress /></div>
          ) : (
            <div style={{ maxHeight: 520, overflow: "auto", paddingRight: 6, color: "#fff" }}>
              <Table responsive className="mb-0 default_table with_hoverbtn mrpdng_tbl">
                <thead style={{ position: "sticky", top: 0, zIndex: 1, background: "rgba(0,0,0,0.6)", color: "#fff" }}>
                  <tr>
                    <th style={{ borderTop: 0 }}>#</th>
                    <th style={{ borderTop: 0 }}>Date</th>
                    <th style={{ borderTop: 0 }}>Question</th>
                    <th style={{ borderTop: 0 }}>Type</th>
                    <th style={{ borderTop: 0 }}>Status</th>
                    <th className="text-right" style={{ borderTop: 0 }}>Token</th>
                  </tr>
                </thead>
                <tbody style={{background: "rgba(0,0,0,0.6)", color: "#FFF" }}>
                  {betHistory && betHistory.length ? (
                    betHistory.map((bet, idx) => (
                      <tr key={bet._id || idx}>
                        <td>{betHistoryPage * betHistoryLimit + (idx + 1)}</td>
                        <td>{bet?.createdAt ? moment(bet.createdAt).format("MMM Do YYYY, h:mm a") : "-"}</td>
                        <td title={bet?.betQuestion || "-"} style={{ maxWidth: 280, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {bet?.betQuestion || "-"}
                        </td>
                        <td>
                          <span className={`label label-inline ${bet?.bet_type === 0 ? "label-light-info" : bet?.bet_type === 1 ? "label-light-primary" : "label-light-warning"}`}>
                            {bet?.bet_type === 0 ? "Custom" : bet?.bet_type === 1 ? "Match" : "Live"}
                          </span>
                        </td>
                        <td>
                          <span className={`label label-inline ${bet?.betStatus === "RESULT" ? "label-light-success" : bet?.betStatus === "CANCELLED" ? "label-light-danger" : "label-light-warning"}`}>
                            {bet?.betStatus || "PENDING"}
                          </span>
                        </td>
                        <td className="text-right">{bet?.bet_amount ?? "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center">No Records</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {betHistoryCount > betHistoryLimit && (
                <div className="d-flex justify-content-end mt-4 pr-2">
                  <BasicPagination
                    totalRecords={betHistoryCount}
                    limit={betHistoryLimit}
                    batch={betHistoryPage + 1}
                    onBatchChange={(batch) => openBetHistoryModal(selectedUsername || "", (batch ? batch - 1 : 0))}
                  />
                </div>
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default WithdrawalRequestTable;
